import { connect } from "react-redux";

import Snackbar from "./Snackbar";
import {
  clearNotification,
  showNotificationDetails
} from "./actions/notifications";

const mapStateToProps = (state, ownProps) => {
  return {
    content: state.ui.notification,
    open: state.ui.notification && state.ui.notification.show === "snackbar"
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onDismiss: () => {
      dispatch(clearNotification());
    },
    showDetails: () => {
      dispatch(showNotificationDetails());
    }
  };
};

const SnackbarContainer = connect(mapStateToProps, mapDispatchToProps)(
  Snackbar
);

export default SnackbarContainer;



// WEBPACK FOOTER //
// ./src/SnackbarContainer.js